export default __webpack_public_path__ + "static/media/photo--lg--56.22974186.jpg";